import { render, staticRenderFns } from "./DrugModal.vue?vue&type=template&id=447c64ef&"
import script from "./DrugModal.vue?vue&type=script&lang=js&"
export * from "./DrugModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports